import { a as __rest } from '../../_tslib.esm.js';
import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import { Slot } from '@radix-ui/react-slot';
import flexStyles from './Flex.styles.esm.js';

/**
 * Flex component for creating flexible layouts using TailwindCSS utility classes.
 * Supports margin utilities.
 */
const Flex = React__default.forwardRef((_a, ref) => {
  var {
      as = "div",
      asChild = false,
      display = "flex",
      direction,
      align,
      justify,
      wrap,
      gap,
      gapX,
      gapY,
      className
    } = _a,
    props = __rest(_a, ["as", "asChild", "display", "direction", "align", "justify", "wrap", "gap", "gapX", "gapY", "className"]);
  const styleOptions = {
    display: typeof display === "string" ? display : (display === null || display === void 0 ? void 0 : display.xs) || undefined,
    smDisplay: typeof display === "object" ? display === null || display === void 0 ? void 0 : display.sm : undefined,
    mdDisplay: typeof display === "object" ? display === null || display === void 0 ? void 0 : display.md : undefined,
    lgDisplay: typeof display === "object" ? display === null || display === void 0 ? void 0 : display.lg : undefined,
    direction: typeof direction === "string" ? direction : (direction === null || direction === void 0 ? void 0 : direction.xs) || undefined,
    smDirection: typeof direction === "object" ? direction === null || direction === void 0 ? void 0 : direction.sm : undefined,
    mdDirection: typeof direction === "object" ? direction === null || direction === void 0 ? void 0 : direction.md : undefined,
    lgDirection: typeof direction === "object" ? direction === null || direction === void 0 ? void 0 : direction.lg : undefined,
    align: typeof align === "string" ? align : (align === null || align === void 0 ? void 0 : align.xs) || undefined,
    smAlign: typeof align === "object" ? align === null || align === void 0 ? void 0 : align.sm : undefined,
    mdAlign: typeof align === "object" ? align === null || align === void 0 ? void 0 : align.md : undefined,
    lgAlign: typeof align === "object" ? align === null || align === void 0 ? void 0 : align.lg : undefined,
    justify: typeof justify === "string" ? justify : (justify === null || justify === void 0 ? void 0 : justify.xs) || undefined,
    smJustify: typeof justify === "object" ? justify === null || justify === void 0 ? void 0 : justify.sm : undefined,
    mdJustify: typeof justify === "object" ? justify === null || justify === void 0 ? void 0 : justify.md : undefined,
    lgJustify: typeof justify === "object" ? justify === null || justify === void 0 ? void 0 : justify.lg : undefined,
    wrap: typeof wrap === "string" ? wrap : (wrap === null || wrap === void 0 ? void 0 : wrap.xs) || undefined,
    smWrap: typeof wrap === "object" ? wrap === null || wrap === void 0 ? void 0 : wrap.sm : undefined,
    mdWrap: typeof wrap === "object" ? wrap === null || wrap === void 0 ? void 0 : wrap.md : undefined,
    lgWrap: typeof wrap === "object" ? wrap === null || wrap === void 0 ? void 0 : wrap.lg : undefined,
    gap: typeof gap === "string" ? gap : (gap === null || gap === void 0 ? void 0 : gap.xs) || undefined,
    smGap: typeof gap === "object" ? gap === null || gap === void 0 ? void 0 : gap.sm : undefined,
    mdGap: typeof gap === "object" ? gap === null || gap === void 0 ? void 0 : gap.md : undefined,
    lgGap: typeof gap === "object" ? gap === null || gap === void 0 ? void 0 : gap.lg : undefined,
    gapX: typeof gapX === "string" ? gapX : (gapX === null || gapX === void 0 ? void 0 : gapX.xs) || undefined,
    smGapX: typeof gapX === "object" ? gapX === null || gapX === void 0 ? void 0 : gapX.sm : undefined,
    mdGapX: typeof gapX === "object" ? gapX === null || gapX === void 0 ? void 0 : gapX.md : undefined,
    lgGapX: typeof gapX === "object" ? gapX === null || gapX === void 0 ? void 0 : gapX.lg : undefined,
    gapY: typeof gapY === "string" ? gapY : (gapY === null || gapY === void 0 ? void 0 : gapY.xs) || undefined,
    smGapY: typeof gapY === "object" ? gapY === null || gapY === void 0 ? void 0 : gapY.sm : undefined,
    mdGapY: typeof gapY === "object" ? gapY === null || gapY === void 0 ? void 0 : gapY.md : undefined,
    lgGapY: typeof gapY === "object" ? gapY === null || gapY === void 0 ? void 0 : gapY.lg : undefined,
    class: className
  };
  const classes = flexStyles(styleOptions);
  const Comp = asChild ? Slot : as;
  return jsx(Comp, Object.assign({
    ref: ref,
    className: classes
  }, props));
});
Flex.displayName = "Flex";

export { Flex };
